import { Component } from '@angular/core';
import { Measurement, MeasurementContext, MeasurementContextDescriptions, SiUnits, UnitType, UsUnits } from 'src/app/shared/data/engineering-enums';
import { EngineeringToolsApiService } from 'src/app/shared/services/engineering-tools-api';
import { UnitConverterService } from 'src/app/shared/services/unit-converter.service';

@Component({
  selector: 'app-unit-converter',
  templateUrl: './unit-converter.component.html',
  styleUrl: './unit-converter.component.scss',
  standalone: false
})
export class UnitConverterComponent {
  constructor(
    private api: EngineeringToolsApiService,
    private unitConverter: UnitConverterService
  ) { }

  public MeasurementContext = MeasurementContext;
  public MeasurementContextDescriptions = MeasurementContextDescriptions;
  public MeasurementContexts = Array.from(MeasurementContextDescriptions.keys());

  public unitContextOptions: UnitContextOption[] = [];

  ngOnInit() {
    this.unitContextOptions = this.MeasurementContexts.map(context => ({
      context,
      usValue: { Value: 100, Unit: UsUnits.get(context) || UnitType.F },
      siValue: { Value: this.unitConverter.Convert(UsUnits.get(context) || UnitType.F, SiUnits.get(context) || UnitType.C, 100), Unit: SiUnits.get(context) || UnitType.C }
    }));
  }

  getUnitText(context: MeasurementContext, isUsUnits: boolean) {
    if (isUsUnits)
      return this.unitConverter.GetUnitText(UsUnits.get(context) || UnitType.F);
    return this.unitConverter.GetUnitText(SiUnits.get(context) || UnitType.C);
  }

  usValueChanged(option: UnitContextOption) {
    option.siValue = {
      Value: this.unitConverter.Convert(
        UsUnits.get(option.context) || UnitType.F,
        SiUnits.get(option.context) || UnitType.C,
        option.usValue.Value
      ),
      Unit: SiUnits.get(option.context) || UnitType.C
    };
  }

  siValueChanged(option: UnitContextOption) {
    option.usValue = {
      Value: this.unitConverter.Convert(
        SiUnits.get(option.context) || UnitType.C,
        UsUnits.get(option.context) || UnitType.F,
        option.siValue.Value
      ),
      Unit: UsUnits.get(option.context) || UnitType.F
    };
  }

}

class UnitContextOption {
  context: MeasurementContext;
  usValue: Measurement;
  siValue: Measurement;
}
